import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
export const OnlineCourses = () => {
  // Add dark mode state
  const [darkMode, setDarkMode] = useState(() => {
    // Check localStorage for saved preference, default to dark mode
    const savedMode = localStorage.getItem('studentDashboardTheme');
    return savedMode === 'dark' || !savedMode; // Default to dark mode if not set
  });
  // Listen for theme changes
  useEffect(() => {
    const handleThemeChange = event => {
      setDarkMode(event.detail.darkMode);
    };
    window.addEventListener('themeChange', handleThemeChange);
    return () => {
      window.removeEventListener('themeChange', handleThemeChange);
    };
  }, []);
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Define text color classes based on dark mode
  const textColorClass = darkMode ? 'text-white' : 'text-gray-800';
  const subtextColorClass = darkMode ? 'text-gray-300' : 'text-gray-600';
  const sectionBgClass = darkMode ? 'bg-white/5' : 'bg-white';
  const borderClass = darkMode ? 'border-white/10' : 'border-gray-200';
  return <div className="max-w-4xl mx-auto px-4 py-8" data-id="element-5318">
      {/* Header */}
      <div className="mb-12" data-id="element-5319">
        <h1 className={`text-3xl md:text-4xl font-bold ${textColorClass} mb-3`} data-id="element-5320">
          Courses — Coming Soon
        </h1>
        <p className={`text-lg ${subtextColorClass}`} data-id="element-5321">
          Maestro Connect is preparing a dedicated courses section focused on
          high-quality music education.
        </p>
        <p className={`text-lg ${subtextColorClass} mt-2`} data-id="element-5322">
          This area will feature structured courses created by experienced
          musicians and educators, covering a wide range of topics across
          instruments, theory, and the music industry.
        </p>
      </div>

      {/* What This Section Will Offer */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} mb-8`} data-id="element-5323">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5324">
          What This Section Will Offer
        </h2>
        <ul className={`space-y-3 ${subtextColorClass}`} data-id="element-5325">
          <li className="flex items-start" data-id="element-5326">
            <span className="mr-3" data-id="element-5327">•</span>
            <span data-id="element-5328">
              Instrument-focused courses (piano, guitar, violin, drums, and
              more)
            </span>
          </li>
          <li className="flex items-start" data-id="element-5329">
            <span className="mr-3" data-id="element-5330">•</span>
            <span data-id="element-5331">Music theory, harmony, and composition</span>
          </li>
          <li className="flex items-start" data-id="element-5332">
            <span className="mr-3" data-id="element-5333">•</span>
            <span data-id="element-5334">Music business, publishing, and career education</span>
          </li>
          <li className="flex items-start" data-id="element-5335">
            <span className="mr-3" data-id="element-5336">•</span>
            <span data-id="element-5337">
              Courses created by professional educators and working musicians
            </span>
          </li>
        </ul>
      </section>

      {/* How Courses Will Be Selected */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} mb-8`} data-id="element-5338">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5339">
          How Courses Will Be Selected
        </h2>
        <p className={`${subtextColorClass} mb-4`} data-id="element-5340">
          Our goal is quality and credibility.
        </p>
        <p className={`${subtextColorClass} mb-3`} data-id="element-5341">Courses may include:</p>
        <ul className={`space-y-3 ${subtextColorClass} mb-4`} data-id="element-5342">
          <li className="flex items-start" data-id="element-5343">
            <span className="mr-3" data-id="element-5344">•</span>
            <span data-id="element-5345">
              Original courses created specifically for Maestro Connect
            </span>
          </li>
          <li className="flex items-start" data-id="element-5346">
            <span className="mr-3" data-id="element-5347">•</span>
            <span data-id="element-5348">Collaborations with established educators and creators</span>
          </li>
          <li className="flex items-start" data-id="element-5349">
            <span className="mr-3" data-id="element-5350">•</span>
            <span data-id="element-5351">
              Carefully selected third-party educational content where
              appropriate
            </span>
          </li>
        </ul>
        <p className={`${subtextColorClass}`} data-id="element-5352">
          Each course will be reviewed to ensure it provides clear educational
          value and practical learning outcomes.
        </p>
      </section>

      {/* Status */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} mb-8`} data-id="element-5353">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5354">Status</h2>
        <p className={`${subtextColorClass}`} data-id="element-5355">
          This section is currently under development and will launch after the
          core platform release. Courses will be added gradually.
        </p>
      </section>

      {/* Get Notified */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} text-center`} data-id="element-5356">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5357">
          Get Notified
        </h2>
        <p className={`${subtextColorClass} mb-6`} data-id="element-5358">
          Join the waitlist to be notified when courses become available.
        </p>
        <Link to="/" className="inline-block bg-deep-pink hover:bg-burgundy text-white font-medium py-3 px-8 rounded-lg transition-colors" data-id="element-5359">
          Join the Waitlist
        </Link>
      </section>
    </div>;
};